import { useEffect } from "react";

/**
 * Ctrl+Shift+P ("P" for prompt) opens the Nucleus dock ready to type, matching
 * the sidebar icon's tooltip.
 *
 * Extracted from DashboardLayout so the gate can be tested (NUC-296). Inline in
 * a 900-line layout it was unreachable by any test, and a mutation reverting it
 * to `role === "ROOT"` passed the whole 458-test suite.
 *
 * `admitted` is the gateway's answer, not a role: this file does not know how
 * admission is decided, and must not re-derive it. The dock it opens is still
 * refused by the gateway's own guard for a caller who should not have it, so
 * this is the UX half of the gate rather than the enforcing one.
 */
export function useNucleusShortcut(
  admitted: boolean,
  openNucleusDock: () => void,
): void {
  useEffect(() => {
    if (!admitted) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (!e.ctrlKey || !e.shiftKey || e.metaKey || e.altKey) return;
      if (e.key.toLowerCase() !== "p") return;
      e.preventDefault();
      openNucleusDock();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [admitted, openNucleusDock]);
}
